import { FC } from "react";
import { IonImg } from "@ionic/react";
import { AllieImgProps } from "./Img.types";

export const AllieImg: FC<AllieImgProps> = (props) => <IonImg {...props} />;
